'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useRef } from 'react';
import { Input } from './elements';
const normalizeNewValue = (currentValue, eventValue) => {
  if (!currentValue) {
    return eventValue.split('');
  }
  if (eventValue.length > 2) {
    return eventValue.split('');
  }
  if (eventValue === '') {
    return [];
  }
  if (currentValue[0] === eventValue[0]) {
    return [eventValue[1]];
  }
  return [eventValue[0]];
};
export const BoxInputField = ({
  index,
  value,
  values,
  type,
  mask,
  autoFocus,
  autoTab,
  inputMode,
  onChange,
  onKeyDown,
  ...rest
}) => {
  const inputRef = useRef();
  const handleInputChange = e => {
    const currentValue = values[index];
    const eventValue = e.target.value;
    const newValues = [...values];
    const rawValue = normalizeNewValue(currentValue, eventValue).slice(0, newValues.length - index);
    const regex = type === 'number' ? /(^$)|(\d+)/ : /.*/;
    const shouldFireChange = rawValue.every(val => regex.test(val));
    if (!onChange) {
      return;
    }
    const newValue = rawValue;
    if (newValue.length) {
      newValue.forEach((val, idx) => newValues[index + idx] = val);
    } else {
      newValues[index] = '';
    }
    if (!shouldFireChange) {
      return;
    }
    onChange(newValues);

    // auto-tab to the specified pin input
    let inputEl = inputRef.current;
    for (let i = 0; i < newValue.length; i++) {
      inputEl = inputEl.nextElementSibling;
    }
    if (newValue && autoTab && inputEl instanceof HTMLInputElement) {
      inputEl.focus();
    }
  };
  const handleKeyDown = e => {
    if (e.key === 'Backspace' && autoTab && values[index] === '' && index > 0) {
      const prevInput = inputRef.current.previousElementSibling;
      if (prevInput instanceof HTMLInputElement) {
        prevInput.focus();
      }
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  // auto-focus on mount
  useEffect(() => {
    if (autoFocus && index === 0) {
      inputRef.current.focus();
    }
  }, [autoFocus, index]);
  return /*#__PURE__*/React.createElement(Input, _extends({}, rest, {
    "aria-label": `Character ${index + 1}`,
    ref: inputRef,
    type: mask ? 'password' : 'text',
    inputMode: inputMode || (type === 'number' ? 'numeric' : 'text'),
    value: value ?? ' ',
    onChange: handleInputChange,
    onKeyDown: handleKeyDown,
    "data-index": index
  }));
};